import React, { Component } from 'react';
import './../AccountOverview/AccountOverview.scss';
import { connect } from 'react-redux';
import { selectedCommittee } from '../../../../../Redux/Actions/EndUser/AccountDetailsActions';
import { auth } from '../../../../../services';
import { Link } from 'react-router-dom';

class CommitteeOverView extends Component {
  constructor(props) {
    super(props);
    this.state = {
      MembershipAssignmentId: 0,
      HasAccepted: null,
      MembershipId: 0,
      PortalUserID: '',
      isBoardMember: false,
    };
  }

  componentDidMount() {
    if (this.props.userCommittees) {
      this.props.userCommittees.map((item, i) => {
        if (item.committeeName && (item.committeeName.replace(/\s/g, '').toUpperCase() == 'BOARDOFDIRECTORS')) {
          this.setState({ isBoardMember: true });
        }
      });
    }

  }

  handleCommitteeChange = (event) => {
    console.log("on committee click", event)
    this.props.selectedCommittee(event);
  }
  render() {
    const committeessDisplay = this.props.userCommittees ? this.props.userCommittees.map((item, i) => {
      if (item.committeeName && item.committeeName.replace(/\s/g, '').toUpperCase() === 'BOARDOFDIRECTORS') {
        return (
          <li className="list-group-item" key={i} onClick={this.handleCommitteeChange(item)}>
            <div className="row littlePadding">
              <div className="col-md-8 colPadding">
                <p><span className="minWidth">Committee Name:</span> <span className="dashboard-info-text"><Link to={`/mycommittee/${item.committeeMemberId}`}>{item.committeeName}</Link></span></p>
              </div>
              <div className="col-md-4 colPadding">
                {/* <p><span className="minWidth">Position:</span> <span className="dashboard-info-text">{item.positionName}</span></p> */}
                <p>
                  <span className="minWidth">
                    <Link className="btnLink btn btn-sm btnPrimary" to={`/mycommittee/${item.committeeMemberId}`}>Member Lookup</Link>
                  </span>
                </p>
              </div>
            </div>
          </li>
        );
      } else {
        return null;
      }
    }) : null;

    if (this.state.isBoardMember) {
      return (
        <div className="my-committees">
          {/* <h3 className="main-title">My Groups/Positions</h3> */}
          <div className="card mb-2">
            <ul className="list-group list-group-flush dashboard-info-list">{committeessDisplay}</ul>
          </div>
        </div>
      );
    } else {
      return null;
    }
  }
}

function mapStateToProps(state) {
  const { user, email, loading } = state.authentication;
  // console.log({jtest: state.accountDetails});
  return {
    user,
    email,
    loading,
    userCommittees: state.accountDetails.userCommittees,
  };
}

export default connect(mapStateToProps, { selectedCommittee })(CommitteeOverView);